import { render, staticRenderFns } from "./websiteHomepage.vue?vue&type=template&id=3c1cdf74&scoped=true&"
import script from "./websiteHomepage.vue?vue&type=script&lang=ts&"
export * from "./websiteHomepage.vue?vue&type=script&lang=ts&"
import style0 from "./websiteHomepage.vue?vue&type=style&index=0&id=3c1cdf74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1cdf74",
  null
  
)

export default component.exports